<app-mat-select-filtered [items]="entities" valueColumn="companyCode" [descriptionColumns]="['companyName']" [loading]="loading" [multiple]="multiple"
  [ngModel]="value" (ngModelChange)="onSelectedValueChange($event)" [placeHolder]="placeHolder" name="value" [required]="required" [disabled]="disabled">
</app-mat-select-filtered>
